// Canonical customer-portal sections + access levels.
//
// This is a deliberate copy of the contract defined for the admin side in
// src/app/customer-portal/portal.service.ts (PortalService). The two must stay
// in sync — the backend (src/root/api/api-portal_public.php API::SECTIONS) is
// the third copy of the same list. If you add/rename a section, update all
// three.

export interface PortalSection {
	key: string;
	label: string;
	icon: string;
}

export const PORTAL_SECTIONS: PortalSection[] = [
	{ key: 'quotes', label: 'Quotes', icon: 'wq wq-handshake' },
	{ key: 'change_orders', label: 'Change Orders', icon: 'wq wq-data-view' },
	{ key: 'invoices', label: 'Invoices', icon: 'wq wq-invoice' },
	{ key: 'documents', label: 'Documents', icon: 'wq wq-copy' },
	{ key: 'sales_order', label: 'Sales Order', icon: 'wq wq-list-box' },
	{ key: 'progress', label: 'Progress', icon: 'wq wq-schedule' }
];

export function sectionMeta(key: string): PortalSection {
	return PORTAL_SECTIONS.find(s => s.key === key) || { key, label: key, icon: '' };
}

// Sections hidden from the portal UI (nav dropdown + project tiles) while their
// components/routes are kept in the codebase. The backend still returns these
// keys; we drop them client-side. Remove a key here to re-enable it.
export const HIDDEN_SECTIONS: string[] = ['sales_order'];

export function visibleSections(keys: string[]): string[] {
	return (keys || []).filter(k => !HIDDEN_SECTIONS.includes(k));
}

// "Needs your attention" badge label for a section, or '' when nothing is
// pending. Shared by the dashboard tiles and the section-switcher dropdown so
// both read identically. Same pending logic as the Progress page (backend).
export function sectionActionText(key: string, count: number): string {
	if (!count) return '';
	switch (key) {
		case 'quotes': return `${count} Action${count === 1 ? '' : 's'} Required`;
		case 'change_orders': return `${count} Change${count === 1 ? '' : 's'} to Review`;
		case 'invoices': return `${count} Payment${count === 1 ? '' : 's'} Due`;
		default: return '';
	}
}
